import BaseService from "@/services/BaseService";

export default class AcceptanceRuleDescriptionService extends BaseService {
  constructor() {
    super('insurance_pricing/acceptance_rules');
  }

  findAll(acceptanceRuleId) {
    return this.http.get(`${this._serviceName}/${acceptanceRuleId}/descriptions`);
  }

  save(acceptanceRuleId, data) {
    return this.http.post(`${this._serviceName}/${acceptanceRuleId}/descriptions`, data);
  }
}
